import React, { useState } from "react";
import "../App.css";

const Number = (props) => {
  const { result, setResult } = props;
  const op = ["/", "+", "-", "*", "."];

  const changeResult = (e) => {
    let clickedBtn = e.target.innerHTML;
    if (clickedBtn === "=") {
      setResult(eval(result).toString());
    } else {
      if (
        (op.includes(clickedBtn) && result === " ") ||
        (op.includes(clickedBtn) && op.includes(result.slice(-1)))
      ) {
        return;
      }

      setResult(result + clickedBtn);
    }
  };

  const deleteBtn = () => {
    if (result === "") {
      return;
    }
    const fresult = result.slice(0, -1);
    setResult(fresult);
  };

  return (
    <>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        7
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        8
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        9
      </button>
      <button
        type="button"
        onClick={() => deleteBtn()}
        className="number-btn del-btn"
      >
        DEL
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        4
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        5
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        6
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn op-btn"
      >
        +
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        1
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        2
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        3
      </button>
      <button
        type="button "
        onClick={(e) => changeResult(e)}
        className="number-btn op-btn"
      >
        -
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn op-btn"
      >
        .
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn"
      >
        0
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn op-btn"
      >
        /
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn op-btn"
      >
        *
      </button>
      <button
        type="button"
        onClick={() => setResult(" ")}
        className="number-btn span-two reset-btn"
      >
        RESET
      </button>
      <button
        type="button"
        onClick={(e) => changeResult(e)}
        className="number-btn span-two equal-btn"
      >
        =
      </button>
    </>
  );
};

export default Number;
